import { isFeatureEnabled } from '../featureToggles.module'

const _getters = {
  canUseAntiPhishing: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-39120-anti-phishing')
  },

  teamNameMaxLength: (_, getters) => {
    return getters.canUseAntiPhishing ? 50 : 100
  },
}

export default _getters
